// extracted by mini-css-extract-plugin
export var cardDistribuidora = "slice-navigation-module--cardDistribuidora--9cc9f";
export var ctaDistr = "slice-navigation-module--ctaDistr--a2b04";
export var ctaIcon = "slice-navigation-module--ctaIcon--295e1";
export var iconBox = "slice-navigation-module--iconBox--02675";
export var preTitle = "slice-navigation-module--preTitle--a5910";
export var textDark = "slice-navigation-module--textDark--4a435";